import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { ReviewPage } from '../../../../../../components/reviews/review-page';
import { PageSkeleton } from '../../../../../../components/ui/skeleton';
import { Forbidden, LoadFailure } from '../../../../../../components/ui/state-views';
import { pillClass } from '../../../../../../components/ui/toolbar-controls';
import { taskQuery, versionsQuery } from '../../../../../../lib/tasks-api';

export const Route = createFileRoute('/subdomain/admin/_staff/workbench/reviews/$taskId')({
  // Two cards side by side, then the checklist and the decision: the same wide canvas as the queue.
  staticData: { wide: true },
  component: ReviewRoute,
});

function ReviewRoute() {
  const { taskId } = Route.useParams();
  const task = useQuery(taskQuery(taskId));
  const versions = useQuery({ ...versionsQuery(taskId), enabled: !!task.data });

  if (task.isLoading || (task.data && versions.isLoading)) return <PageSkeleton />;

  if (!task.data || !versions.data) {
    return (
      <LoadFailure
        error={task.error}
        noun="review"
        forbiddenHint="Only a lead on it, its account manager or an admin can."
        action={
          <Link to="/subdomain/admin/workbench/reviews" search={{}} className={pillClass('light', 'lg')}>
            Back to the queue
          </Link>
        }
        onRetry={() => {
          void task.refetch();
          void versions.refetch();
        }}
      />
    );
  }

  // The lead's page: the API decides who may answer; anyone else is told and sent back, not shown dead buttons.
  if (!task.data.access.publish) {
    return (
      <div className="rounded-(--mbm-component-radius-card) border border-border-line bg-surface-card">
        <Forbidden
          title="You can’t review this task"
          description="Only a lead on it, its account manager or an admin can approve a version."
          action={
            <Link to="/subdomain/admin/tasks/$taskId" params={{ taskId }} className={pillClass('light', 'lg')}>
              Open the task
            </Link>
          }
        />
      </div>
    );
  }

  return <ReviewPage task={task.data} versions={versions.data} />;
}
